import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './Notification.css';
import { useNotification as useNotificationHook } from '../../hooks/useNotification';

function Notification(props) {
  const { notification, hideNotification } = useNotificationHook();

  const isOpen = props.isOpen ?? notification.isOpen;
  const message = props.message ?? notification.message;
  const button1 = props.button1 ?? notification.button1;
  const button2 = props.button2 ?? notification.button2;
  const duration = props.duration ?? notification.duration ?? 0; // 0 means no auto-close
  const onClose = props.onClose ?? hideNotification;
  useEffect(() => {
    if (!isOpen || duration === 0) return;
    const timer = setTimeout(() => {
      onClose && onClose();
    }, duration);
    return () => clearTimeout(timer);
  }, [isOpen, duration, onClose]);

  const handleButton1Click = () => {
    if (button1?.onClick) {
      button1.onClick();
    }
    if (button1?.closeOnClick !== false) {
      onClose && onClose();
    }
  };

  const handleButton2Click = () => {
    if (button2?.onClick) {
      button2.onClick();
    }
    if (button2?.closeOnClick !== false) {
      onClose && onClose();
    }
  };

  const handleOverlayClick = (e) => {
    // Only close if clicking on the overlay itself, not the notification content
    if (e.target === e.currentTarget) {
      onClose && onClose();
    }
  };

  if (!isOpen) return null;

  const content = (
    <div className="notification-overlay" onClick={handleOverlayClick}>
      <div className={`notification ${isOpen ? 'open' : ''}`} role="dialog" aria-modal="true">
        <div className="notification-content">
          <div className="notification-message">{message}</div>

          <div className="notification-buttons">
            {button1 && (
              <button
                className={`notification-button ${button2 ? 'notification-button-half' : 'notification-button-full'}`}
                onClick={handleButton1Click}
                style={button1.style || {}}
              >
                {button1.icon && <span className="notification-button-icon">{button1.icon}</span>}
                {button1.text}
              </button>
            )}

            {button2 && (
              <button
                className="notification-button notification-button-half"
                onClick={handleButton2Click}
                style={button2.style || {}}
              >
                {button2.icon && <span className="notification-button-icon">{button2.icon}</span>}
                {button2.text}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(content, document.body);
}

export default Notification;
